import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptSpeakerAssigned, {
	type TranscriptSpeakerAssignedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakerAssigned';
import transcriptSpeakerAssignmentFailed, {
	type TranscriptSpeakerAssignmentFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakerAssignmentFailed';
import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';
import type AssignTranscriptSpeaker from '@Application/Beneficiaries/Transcripts/Commands/AssignTranscriptSpeaker';
import { put } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptSpeakerAssignedAction | TranscriptSpeakerAssignmentFailedAction;

export default (command: AssignTranscriptSpeaker) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<TranscriptSpeakerPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/transcript/speakers/${command.speakerId}`,
				command.toJSON(),
			);

			const action = transcriptSpeakerAssigned(payload, command.interviewId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptSpeakerAssignmentFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
